import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/authContext/AuthContext';
import { EnvoieContextProvider } from './context/envoieContext/EnvoieContext';
import { AgenceContextProvider } from './context/agenceContext/AgenceContext';
import { StatistiqueContextProvider } from './context/statistiqueContext/StatistiqueContext';
import { InfopersonContextProvider } from './context/infopersonContext/InfopersonContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatistiqueContextProvider>
      <InfopersonContextProvider>
        <AgenceContextProvider>
          <EnvoieContextProvider>
            <AuthContextProvider>
              <App />
            </AuthContextProvider>
          </EnvoieContextProvider>
        </AgenceContextProvider>
      </InfopersonContextProvider>
    </StatistiqueContextProvider>
  </React.StrictMode>
);
